import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import pageNotFound from 'assets/images/404-page.png'

const PageNotFound: React.FC = () => {
  return (
    <Box 
      sx={{ 
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: 'calc(100vh - 120px)', sm: 'calc(100vh - 140px)' },
        px: { xs: 2, sm: 4 },
        py: { xs: 4, sm: 6 }
      }}
    >
      <Box
        component="img"
        src={pageNotFound}
        alt="Page Not Found - 404"
        sx={{
          maxWidth: { xs: '95vw', sm: '80vw', md: '70vw' },
          height: 'auto',
          mb: { xs: 2, sm: 3 }
        }}
      />
      <Typography
        component="p"
        sx={{
          fontSize: { xs: '0.875rem', sm: '1rem' },
          mt: { xs: 1, sm: 2 }
        }}
      >
        <Link 
          to="/"
          style={{ 
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: 'bold'
          }}
        >
          Go to Home
        </Link>
      </Typography>
    </Box>
  )
}

export default PageNotFound
